<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid d-flex flex-row justify-content-between">
      <a class="navbar-brand" href="javascript:void(0)">Voucher Usage (Random)</a>
    </div>
  </nav>
  <hr/>
  <div class="row">
    <app-tablev2 #table></app-tablev2>
  </div>